/* ============================================================
   Recherche prédictive — JS original (Stratégie 2)
   Section Rendering : /search/suggest?q=…&section_id=predictive-search
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var panel = document.querySelector('[data-lf-search]');
    if (!panel || panel.dataset.bound) return;
    panel.dataset.bound = '1';

    var openers = document.querySelectorAll('[data-lf-search-open]');
    var closers = panel.querySelectorAll('[data-lf-search-close]');
    var input = panel.querySelector('[data-lf-search-input]');
    var results = panel.querySelector('[data-lf-search-results]');
    var debounce, controller;

    // Focus garde dans le panneau tant qu'il est ouvert : voir lf-calque.js.
    function open(e) {
      if (e) e.preventDefault();
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (window.lfCalque) window.lfCalque.ouvrir(panel, { focus: input });
      else setTimeout(function () { input.focus(); }, 50);
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      results.innerHTML = '';
      if (window.lfCalque) window.lfCalque.fermer(panel);
    }

    openers.forEach(function (o) { o.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(function () { fetchResults(q); }, 250);
    });

    function fetchResults(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');
      var base = window.lfRoutes.predictiveSearch;
      var url = base + '?q=' + encodeURIComponent(q) +
                '&section_id=predictive-search' +
                '&resources[type]=product,page,article,query&resources[limit]=6';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = fresh ? fresh.innerHTML : html;
          results.classList.remove('is-loading');
        })
        .catch(function (e) { if (e.name !== 'AbortError') results.classList.remove('is-loading'); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
